__turbopack_context__.v({
  "popover": "dialInsPopover-module-scss-module__n1jT1W__popover",
  "popoverContainer": "dialInsPopover-module-scss-module__n1jT1W__popoverContainer",
  "popoverText": "dialInsPopover-module-scss-module__n1jT1W__popoverText",
});
